<template>
  <!-- eslint-disable max-len -->
  <div>
    <!-- header -->
    <v-container>
      <v-row class="mb-12 mt-12">
        <v-col>
          <div>
            <p class="display-1 font-weight-light primary--text">Review <span v-if="isSelfSurvey">and submit</span></p>
          </div>

          <!-- title section -->
          <div>
            <p class="headline">
              Please review your responses below and submit your feedback.
              <b v-if="isSelfSurvey">You will then be asked to nominate juniors, seniors and peers to provide feedback on you.</b>
            </p>
          </div>

          <v-row justify="center">
            <v-expansion-panels  :value=1 >
              <v-expansion-panel v-for="(surveyPage, i) in surveyFlow" :key="i + 1">
                <v-expansion-panel-header class="font-weight-black primary--text headline"
                                          v-if="surveyPage != 'Intro' && surveyPage !=  'Summary' && surveyPage !=  'SurveyEnd' && surveyPage !=  'Nominate'">
                  {{ questions[i - 1].title}} <i style="font-size: 20px;" class="font-weight-light ml-2" v-if="questions[i - 1].isSkipped">(section skipped)</i>
                </v-expansion-panel-header>
                <v-expansion-panel-content  v-if="surveyPage != 'Intro' && surveyPage !=  'Summary' && surveyPage !=  'SurveyEnd'  && surveyPage !=  'Nominate'">
                  <div>
                    <Driver v-for="driver in questions[i - 1].drivers" :pageNr="i + 1"
                            :key="`${driver.field}_ summary`"
                            v-bind:isSummaryView=true
                            v-bind:driver="driver">
                    </Driver><!-- eslint-disable max-len -->
                    <Verbatim  v-bind:isSummaryView=true v-bind:verbatim="questions[i - 1].verbatim"></Verbatim>
                  </div>
                  <v-btn class="ma-2" tile color="grey" @click="previousPage(surveyFlow.indexOf(questions[i - 1].field) + 1)">
                    <v-icon left>mdi-pencil</v-icon> Go back and edit
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

import Driver from '@/components/ATK_360_v1/Driver.vue';
import Verbatim from '@/components/ATK_360_v1/Verbatim.vue';

export default {
  name: 'SummaryView',

  components: {
    Driver,
    Verbatim,
  },
  data() {
    return {
      isSummaryView: true,
    };
  },
  computed: {
    ...mapGetters([
      'isSelfSurvey',
      'surveyFlow',
    ]),
    questions() {
      const eligibleQuestions = [];
      for (let i = 0; i < this.$store.state.questions.length; i += 1) {
        if (this.surveyFlow.indexOf(this.$store.state.questions[i].field) !== -1) {
          const q = this.$store.state.questions[i];
          q.isSkipped = this.$store.state.response[`${this.$store.state.skip.field}_${q.field}`] != null
            && this.$store.state.response[`${this.$store.state.skip.field}_${q.field}`] !== '';
          eligibleQuestions.push(q);
        }
      }
      return eligibleQuestions;
    },
  },
  methods: {
    previousPage(stepNumber) {
      this.$store.commit('previousPage', stepNumber);
    },
    nextButton() {
      this.$store.commit('incrementCurrentStep');

      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

      const isCompleted = (this.$store.state.currentStep === this.surveyFlow.length);

      this.$store.commit('storeResponse', {
        k: 'IsCompleted',
        v: isCompleted,
      });

      // Completed
      if (isCompleted) {
        this.$store.commit('storeResponse', {
          k: 'DateCompleted',
          v: new Date(),
        });
      }

      this.$store.dispatch('storeResponse');
    },
  },
};
</script>

<style>
  .v-expansion-panel-content__wrap {
    padding: 0 10px 16px !important;
  }
</style>

<style scoped>

  .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{
    color: #7823dc !important;
    font-size: 36px !important;
    font-weight: bolder !important;
  }

  .v-expansion-panel-header{
    padding: 15px 10px;
  }

  .v-expansion-panel-header,.theme--light.v-expansion-panels .v-expansion-panel{
    background-color:#fafafa !important;
  }

</style>
